import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "steps is-narrow is-medium is-centered has-content-centered" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<span class=\"steps-marker\"><span class=\"icon\"><i class=\"fa fa-clipboard\"></i></span></span><div class=\"steps-content\"><p class=\"heading\">Project description</p></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-users" })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "steps-content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "heading" }, "Technology")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-dollar-sign" })
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "steps-content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "heading" }, "Exploitation")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-seedling" })
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "steps-content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "heading" }, "Investment")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check" })
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "steps-content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "heading" }, "Payment")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", {
      class: _normalizeClass(["steps-segment has-gaps", { 'is-active': _ctx.step0 }])
    }, _hoisted_4, 2),
    _createElementVNode("li", {
      class: _normalizeClass(["steps-segment has-gaps", { 'is-active': _ctx.step1 }])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["steps-marker", { 'is-hollow': _ctx.step0 }])
      }, _hoisted_6, 2),
      _hoisted_7
    ], 2),
    _createElementVNode("li", {
      class: _normalizeClass(["steps-segment has-gaps", { 'is-active': _ctx.step2 }])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["steps-marker", { 'is-hollow': _ctx.step1 }])
      }, _hoisted_9, 2),
      _hoisted_10
    ], 2),
    _createElementVNode("li", {
      class: _normalizeClass(["steps-segment has-gaps", { 'is-active': _ctx.step3 }])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["steps-marker", { 'is-hollow': _ctx.step2 }])
      }, _hoisted_12, 2),
      _hoisted_13
    ], 2),
    _createElementVNode("li", {
      class: _normalizeClass(["steps-segment", { 'is-active': _ctx.step4 }])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["steps-marker", { 'is-hollow': _ctx.step3 }])
      }, _hoisted_15, 2),
      _hoisted_16
    ], 2)
  ]))
}